import React from 'react';
import PropTypes from 'prop-types';

import { Text } from './style';

const Code = ({ value }) => (
  <Text>{value}</Text>
);
Code.propTypes = {
  value: PropTypes.string,
};
Code.defaultProps = {
  value: '',
};

export default Code;
